import type { GoDate } from '$lib/datetimes'
import type { NullTime } from '$lib/types/client_types'

export type ExpensesFieldDef = {
	DB_field: string
	IA_field: string
	name: string
	index: number
	caption: string
}

export const ExpensesFieldsDefArray : ExpensesFieldDef[] = [
	// { 'DB_field' : '1', 'IA_field' : '0', 'name' : 'id', 					'index' :  0, 'caption' : 'id' 						},
	// { 'DB_field' : '1', 'IA_field' : '0', 'name' : 'account_id', 			'index' :  0, 'caption' : 'account_id' 				},
	// { 'DB_field' : '1', 'IA_field' : '0', 'name' : 'status', 				'index' :  0, 'caption' : 'status' 					},
	{ 'DB_field' : '1', 'IA_field' : '0', 'name' : 'file_name', 				'index' :  0, 'caption' : 'file_name' 					},
	// { 'DB_field' : '1', 'IA_field' : '0', 'name' : 'expense_category_id', 	'index' :  0, 'caption' : 'expense_category_id' 		},
	{ 'DB_field' : '1', 'IA_field' : '0', 'name' : 'expense_category', 			'index' :  0, 'caption' : 'expense_category' 			},
	{ 'DB_field' : '1', 'IA_field' : '0', 'name' : 'currency_id', 				'index' :  0, 'caption' : 'currency_id' 				},

	{ 'DB_field' : '0', 'IA_field' : '1', 'name' : 'DOCUMENT_TYPE', 			'index' :  1, 'caption' : 'document_type' 				},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'INVOICE_RECEIPT_ID', 		'index' :  2, 'caption' : 'invoice_receipt_id'			},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'INVOICE_RECEIPT_DATE', 		'index' :  3, 'caption' : 'invoice_receipt_date'		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'PO_NUMBER', 				'index' :  4, 'caption' : 'po_number'					},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'ORDER_DATE', 				'index' :  5, 'caption' : 'order_date'					},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'DUE_DATE', 					'index' :  6, 'caption' : 'due_date'					},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'DELIVERY_DATE', 			'index' :  7, 'caption' : 'delivery_date'				},
	
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'CUSTOMER_NUMBER', 			'index' :  8, 'caption' : 'customer_number'			},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'ACCOUNT_NUMBER', 			'index' :  9, 'caption' : 'account_number'				},
	
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'VENDOR_NAME',	 			'index' :  10, 'caption' : 'vendor_name'				},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'VENDOR_ADDRESS', 			'index' :  11, 'caption' : 'vendor_address'			},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'VENDOR_ABN_NUMBER', 		'index' :  12, 'caption' : 'vendor_abn_number'			},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'VENDOR_GST_NUMBER', 		'index' :  13, 'caption' : 'vendor_gst_number'			},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'VENDOR_PAN_NUMBER', 		'index' :  14, 'caption' : 'vendor_pan_number'    		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'VENDOR_VAT_NUMBER', 		'index' :  15, 'caption' : 'vendor_vat_number'    		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'VENDOR_PHONE', 				'index' :  16, 'caption' : 'vendor_phone'         		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'VENDOR_URL', 				'index' :  17, 'caption' : 'vendor_url'           		},
	
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'RECEIVER_NAME', 			'index' :   18, 'caption' : 'receiver_name'        		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'RECEIVER_ADDRESS', 			'index' :   19, 'caption' : 'receiver_address'    		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'RECEIVER_ABN_NUMBER', 		'index' :  	20, 'caption' : 'receiver_abn_number'  		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'RECEIVER_GST_NUMBER', 		'index' :  	21, 'caption' : 'receiver_gst_number'  		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'RECEIVER_PAN_NUMBER', 		'index' :  	22, 'caption' : 'receiver_pan_number'		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'RECEIVER_VAT_NUMBER', 		'index' :  	23, 'caption' : 'receiver_vat_number'  		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'RECEIVER_PHONE', 			'index' :   24, 'caption' : 'receiver_phone'      		},
	
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'SUBTOTAL', 					'index' : 	25, 'caption' : 'subtotal'            		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'DISCOUNT', 					'index' :   26, 'caption' : 'discount'           		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'TAX_PAYER_ID', 				'index' :   27, 'caption' : 'tax_payer_id'         		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'TAX', 						'index' :   28, 'caption' : 'tax'                  		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'TOTAL', 					'index' :   29, 'caption' : 'total'               		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'AMOUNT_PAID', 				'index' :   30, 'caption' : 'amount_paid'          		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'AMOUNT_DUE', 				'index' :   31, 'caption' : 'amount_due'           		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'SERVICE_CHARGE', 			'index' :   32, 'caption' : 'service_charge'       		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'GRATUITY', 					'index' : 	33, 'caption' : 'gratuity'             		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'PRIOR_BALANCE', 			'index' :   34, 'caption' : 'prior_balance'        		},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'SHIPPING_HANDLING_CHARGE', 	'index' : 	35, 'caption' : 'shipping_handling_charge'	},
	{ 'DB_field' : '1', 'IA_field' : '1', 'name' : 'PAYMENT_TERMS', 			'index' :   36, 'caption' : 'payment_terms'      		},
	{ 'DB_field' : '0', 'IA_field' : '1', 'name' : 'OTHER',						'index' :	900, 'caption' : 'other'   				    },

	{ 'DB_field' : '1', 'IA_field' : '0', 'name' : 'note', 						'index' :   9000, 'caption' : 'note' 					},
	{ 'DB_field' : '1', 'IA_field' : '0', 'name' : 'doc_pages', 				'index' :   9000, 'caption' : 'doc_pages' 				},
	{ 'DB_field' : '1', 'IA_field' : '0', 'name' : 'created_at', 				'index' :   9000, 'caption' : 'created_at' 				},
	{ 'DB_field' : '1', 'IA_field' : '0', 'name' : 'archived', 					'index' :   9000, 'caption' : 'archived' 				},
	{ 'DB_field' : '0', 'IA_field' : '0', 'name' : 'archived_at', 				'index' :   9000, 'caption' : 'archived_at' 			},
]

export function getExpensesFieldsDB() {
	const filteredArray = ExpensesFieldsDefArray.filter((info) => info.DB_field=='1')
	const mappedArray = filteredArray.map(function(info) { info.name=info.name.toLowerCase(); return info })
	return mappedArray
}
export function getExpensesFieldsDB_OrderByAlphabetic() {
	const filteredArray = ExpensesFieldsDefArray.filter((info) => info.DB_field=='1')
	let mappedArray = filteredArray.map(function(info) { info.name=info.name.toLowerCase(); return info })
	mappedArray = mappedArray.sort((fieldDef1, fieldDef2) => fieldDef1.name.localeCompare(fieldDef2.name))
	return mappedArray
}

export function getExpensesFieldsIA() {
	const filteredArray = ExpensesFieldsDefArray.filter((info) => info.IA_field=='1')
	const mappedArray = filteredArray.map(function(info) { info.name=info.name.toUpperCase(); return info })
	return mappedArray
}

/*
export function getExpensesFieldsMap() {
	const jsonMap = new Map()
	for (const key in ExpensesFieldsDefArray) {
	    jsonMap.set(ExpensesFieldsDefArray[key].name, ExpensesFieldsDefArray[key].index)
	}
	return jsonMap
}
*/

export type Expense = {
	/*
	id: string
	account_id: string
	status: ExpenseStatus
	file_name: string
	expense_category_id: string | null
	invoice_receipt_id: string
    invoice_receipt_date: Date //string //NullTime
	vendor_name: string
	total: Big
	
	currency_id: string
	doc_pages: number
	note: string
	data_raw: AnalyzeExpenseResponse  // JSONObject
	created_at: number
	archived: boolean
	archived_at: number
	*/
	id : string,
	account_id : string
	status : ExpenseStatus
	file_name : string
	expense_category_id : string | null
	expense_category : string
	currency_id : string
	invoice_receipt_id : string
	invoice_receipt_date : Date //string //NullTime
	po_number : string
	order_date : Date
	due_date : Date
	delivery_date : Date
	customer_number : string
	account_number : string
	vendor_name : string
	vendor_address : string
	vendor_abn_number : string
	vendor_gst_number : string
	vendor_pan_number : string
	vendor_vat_number : string
	vendor_phone : string
	vendor_url : string
	receiver_name : string
	receiver_address : string
	receiver_abn_number : string
	receiver_gst_number : string
	receiver_pan_number : string
	receiver_vat_number : string
	receiver_phone : string
	subtotal : number
	discount : number
	tax_payer_id : string
	tax  : number
	total : Big
	amount_paid : number
	amount_due : number
	service_charge : number
	gratuity : string
	prior_balance : string
	shipping_handling_charge : string
	payment_terms : string
	note : string
	data_raw: AnalyzeExpenseResponse  // JSONObject
	doc_pages : number 
	created_at : number
	archived : boolean
	archived_at : number	
}

export type ExpenseListItem = {
	id : string,
	account_id : string
	status : ExpenseStatus
	file_name : string
	expense_category_id : string | null
	expense_category : string
	currency_id : string
	invoice_receipt_id : string
	invoice_receipt_date : Date
	po_number : string
	order_date : Date
	due_date : Date
	delivery_date : Date
	customer_number : string
	account_number : string
	vendor_name : string
	vendor_address : string
	vendor_abn_number : string
	vendor_gst_number : string
	vendor_pan_number : string
	vendor_vat_number : string
	vendor_phone : string
	vendor_url : string
	receiver_name : string
	receiver_address : string
	receiver_abn_number : string
	receiver_gst_number : string
	receiver_pan_number : string
	receiver_vat_number : string
	receiver_phone : string
	subtotal : Big
	discount : Big
	tax_payer_id : string
	tax  : Big
	total : Big
	amount_paid : Big
	amount_due : Big
	service_charge : Big
	gratuity : string
	prior_balance : string
	shipping_handling_charge : string
	payment_terms : string
	note : string
	// data_raw, 
	doc_pages : number 
	created_at : number
	archived : boolean
	archived_at : number
}

// type JSONObject =
//     | string
//     | number
//     | boolean
//     | { [x: string]: JSONObject }
//     | Array<JSONObject>

export enum ExpenseStatus {
	Draft = 'draft',
	Processed = 'processed',
	Archived = 'archived',
	// Error = 'error'
}

export type ServerExpense = {
/*
	id: string
	account_id: string
	status: ExpenseStatus
	file_name: string
	invoice_receipt_id: string
	invoice_receipt_date: GoDate //string // NullTime
	vendor_name: string
	total: string
	
	currency_id: string
	doc_pages: number
	note: string
	data_raw: AnalyzeExpenseResponse
	created_at: number
	archived: boolean
	archived_at: number
*/
	id : string,
	account_id : string
	status : ExpenseStatus
	file_name : string
	expense_category_id : string | null
	currency_id : string
	invoice_receipt_id : string
	invoice_receipt_date: GoDate //string // NullTime
	po_number : string
	order_date : NullTime
	due_date : NullTime
	delivery_date : NullTime
	customer_number : string
	account_number : string
	vendor_name : string
	vendor_address : string
	vendor_abn_number : string
	vendor_gst_number : string
	vendor_pan_number : string
	vendor_vat_number : string
	vendor_phone : string
	vendor_url : string
	receiver_name : string
	receiver_address : string
	receiver_abn_number : string
	receiver_gst_number : string
	receiver_pan_number : string
	receiver_vat_number : string
	receiver_phone : string
	subtotal : string
	discount : string
	tax_payer_id : string
	tax  : string
	total : string
	amount_paid : string
	amount_due : string
	service_charge : string
	gratuity : string
	prior_balance : string
	shipping_handling_charge : string
	payment_terms : string
	note : string
	data_raw: AnalyzeExpenseResponse
	doc_pages : string 
	created_at : number
	archived : boolean
	archived_at : NullTime
}

export type ServerExpenseListItem = {
/*	
	id: string
	status: ExpenseStatus
	file_name: string
	invoice_receipt_id: string
    invoice_receipt_date: string //NullTime
	vendor_name: string
	total: string
	
	currency_id: string
	doc_pages: number
	note: string
	// data_raw: AnalyzeExpenseResponse
	created_at: number
	archived: boolean
	archived_at: number
*/
	id : string,
	account_id : string
	status : ExpenseStatus
	file_name : string
	expense_category_id : string | null
	expense_category : string
	currency_id : string
	invoice_receipt_id : string
	invoice_receipt_date: GoDate //string // NullTime
	po_number : string
	order_date : NullTime
	due_date : NullTime
	delivery_date : NullTime
	customer_number : string
	account_number : string
	vendor_name : string
	vendor_address : string
	vendor_abn_number : string
	vendor_gst_number : string
	vendor_pan_number : string
	vendor_vat_number : string
	vendor_phone : string
	vendor_url : string
	receiver_name : string
	receiver_address : string
	receiver_abn_number : string
	receiver_gst_number : string
	receiver_pan_number : string
	receiver_vat_number : string
	receiver_phone : string
	subtotal : string
	discount : string
	tax_payer_id : string
	tax  : string
	total : string
	amount_paid : string
	amount_due : string
	service_charge : string
	gratuity : string
	prior_balance : string
	shipping_handling_charge : string
	payment_terms : string
	note : string
	//data_raw: AnalyzeExpenseResponse
	doc_pages : string 
	created_at : number
	archived : boolean
	archived_at : NullTime
}

export type ExpensesParams = {
	statuses: ExpenseStatus[]
	archived: boolean[]
	query: string
	// expense_id: string
	date_start: Date | null
	date_end: Date | null
}

export const allStatuses = [
	ExpenseStatus.Draft,
	ExpenseStatus.Processed,
	ExpenseStatus.Archived
]

export enum ExpensesStatusFilter {
	All = 'all',
	Archived = 'archived'
}


// =========================================================================================
// TypeScript type definition for AWS Textract AnalyzeExpense API response
export type AnalyzeExpenseResponse = {
	DocumentMetadata: DocumentMetadata
	ExpenseDocuments: ExpenseDocument[]
	AnalyzeExpenseModelVersion?: string
	ResponseMetadata?: ResponseMetadata
  }
  
export type DocumentMetadata = {
	Pages: number
  }
  
export type ExpenseDocument = {
	ExpenseIndex: number
	SummaryFields?: ExpenseField[]
	LineItemGroups?: LineItemGroup[]
	Blocks?: Block[]
  }
  
export type ExpenseField = {
	Type: ExpenseType
	LabelDetection: ExpenseDetection
	ValueDetection: ExpenseDetection
	PageNumber?: number
	Currency?: ExpenseCurrency
	GroupProperties?: GroupProperty[]

	Inv_Index: number    // custom field  
  }

export type SummaryField = {
	key: string
	value: string
}

export type ExpenseType = {
	Text: string
	// INVOICER-Custom Edited value
	Inv_TextEdited?: string
	Confidence: number
  }
  
export type ExpenseDetection = {
	Text: string
	// INVOICER-Custom Edited value
	Inv_TextEdited?: string
	Confidence: number
	Geometry: Geometry
	Id?: string
	Relationships?: Relationship[]
  }
  
export type Geometry = {
	BoundingBox: BoundingBox
	Polygon?: Point[]
  }
  
export type BoundingBox = {
	Width: number
	Height: number
	Left: number
	Top: number
  }
  
export type Point = {
	X: number
	Y: number
  }
  
export type ExpenseCurrency = {
	Code: string
	Confidence: number
  }
  
export type LineItemGroup = {
	LineItemGroupIndex: number
	LineItems: LineItemFields[]
	PageNumber?: number
  }
  
export type LineItemFields = {
	LineItemExpenseFields: ExpenseField[]
	PageNumber?: number
  }
  
export type Block = {
	BlockType: string
	Confidence?: number
	Text?: string
	TextType?: string
	RowIndex?: number
	ColumnIndex?: number
	RowSpan?: number
	ColumnSpan?: number
	Geometry: Geometry
	Id: string
	Relationships?: Relationship[]
	EntityTypes?: string[]
	SelectionStatus?: string
	Page?: number
	Query?: Query
	Answer?: Answer
  }
  
export type Relationship = {
	Type: string
	Ids: string[]
  }
  
export type GroupProperty = {
	Types?: string[]
	Id?: string
  }
  
export type Query = {
	Text?: string
	Alias?: string
	Pages?: string[]
  }
  
export type Answer = {
	Text?: string
	Confidence?: number
  }
  
export type ResponseMetadata = {
	RequestId: string
	HTTPStatusCode: number
	HTTPHeaders: HTTPHeaders
	RetryAttempts: number
  }
  
export type HTTPHeaders = {
	[header: string]: string
  }
  